<template>
    <multiselect
        v-if="propertyTenures.options.length > 0"
        class="property-tenure-select py-1 px-3"
        :options="propertyTenures.options"
        v-model="selectedTenure"
        :hide-selected="false"
        :preselectFirst="true"
        :showLabels="false"
        :group-select="false"
        selectLabel=""
        placeholder=""
        tagPlaceholder=" "
        deselectLabel=""
        :searchable="true"
    >
        <template #caret="{ toggle }">
            <caret-icon
                @mousedown.prevent.stop="toggle"
                :solid="true"
                :hide="propertyTenures.options.length === 0"
            ></caret-icon>
        </template>
        <template slot="singleLabel" slot-scope="props">
            <span class="option__desc">
                <span class="option__title">{{ props.option }}</span>
            </span>
        </template>
        <template slot="option" slot-scope="props">
            <div class="option__desc">
                <span class="option__title">{{ props.option }}</span>
            </div>
        </template>
    </multiselect>
</template>

<script>
import PropertyTenure from '@/services/Property/PropertyTenure';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      propertyTenures: {
        options: [],
      },
      selectedTenure: this.$store.getters.propertyTenure,
    };
  },

  watch: {
    selectedTenure(value) {
      if (value === null) {
        this.selectedTenure = this.$store.getters.propertyTenure;
        return;
      }

      this.setPropertyTenure(value);
    },
  },

  computed: {
    ...mapGetters({ clientId: 'userClientId' }),
  },
  async mounted() {
    const user = this.$store.getters.authUser;

    await this.getPropertyTenures();

    if (this.$route.query.tenure !== undefined) {
      this.setPropertyTenure(this.$route.query.tenure.trim());
      this.selectedTenure = this.$route.query.tenure.trim();

      // eslint-disable-next-line
      history.pushState({}, null, `${this.$route.path}`);
    } else if (!this.$store.getters.propertyTenure) {
      // Set the first item as the default if not already set
      this.setPropertyTenure(this.propertyTenures.options[0]);
    }
  },

  methods: {
    ...mapActions(['setPropertyTenure']),
    async getPropertyTenures() {
      const params = {
        params: {
          complianceTypeId: this.$store.getters.complianceTypeId,
        },
      };
      const { data } = await PropertyTenure.list(this.clientId, params);
      this.propertyTenures.options = data.data;
    },
  },
};
</script>

<style lang="scss">
.property-tenure-select {
    margin-right: 5px;
    height: 33px;
    min-height: 33px;

    .multiselect_ {
        &_tags {
            border: none;
            background-color: unset;
            font-weight: bold;
            padding-left: 0;
            padding-top: 0;
            min-height: 28px;
            padding-right: 15px;
            min-width: 118px;

            .option__desc {
                margin-left: 8px;
            }
        }

        &_single {
            padding: 0;
            margin: 0;
            background-color: unset;

            .option__title {
                line-height: 34px;
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
            }
        }

        &_option {
            &:hover {
                background: #F7F9FA;
            }

            &--highlight {
                background: $white;
                color: $black;
            }
        }

        &_caret {
            top: 8px;
            right: 0;
        }

        &_content-wrapper {
            top: 42px;
            max-height: fit-content;
            padding: 0.5rem 0;
            margin: 0.125rem 0 0;
            font-size: 1rem;
            color: #4E738A;
            text-align: left;
            list-style: none;
            background-color: #ffffff;
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 0.25rem;

            .option__desc {
                display: inline-block;
                margin-left: 10px;
            }
        }

        &_input {
            margin-top: 5px;
            padding: 4px;
        }
    }
}

.spacer {
    position: relative;
    top: 13px;
    height: 15px;
    width: 2px;
    margin: 0 22px;
    background: #000;
}

@media screen and (max-width: 767px) {
  .property-tenure-select {
    max-width: 40px;
    .multiselect__input {
      display: none;
    }
  }
}

@media screen and (max-width: 1024px) {
    .property-tenure-select {
        .multiselect_ {
            &_tags {
                height: 28px;
                padding-right: 0;
            }

            &_single {
                .option__desc {
                    .option__title {
                        display: none;
                    }
                }
            }

            &_caret {
                left: 50px;
            }

            &_content-wrapper {
                top: 39px;
            }
        }
    }

    .spacer {
        margin: 0;
    }

    .sub-nav /deep/ {
        .nav-items {
            max-width: 90vw !important;
            width: 100%;

            &.has-actions {
                max-width: calc(82vw - 105px) !important;
            }
        }
    }
}
</style>
